import { useToast } from 'src/app/useToast';
import useApiEndpoints from 'src/context/useApiEndpoints';

export default () => {
    const { getApiEndpointFromUrl } = useApiEndpoints();
    const { toastError } = useToast();

    // TODO: TYPE-SAFETY - Parameter 'state' has implicit 'any' type. Should define explicit interface for better type safety
    const processApiEndpointError = (state) => {
        if (state.status !== 'error' || !state.error.response) return;

        const endpoint = getApiEndpointFromUrl(state.endpoint);
        const status = state.error.response.status;
        const errorMsg = endpoint?.errorMessage;

        if (status === 401) {
            toastError('You do not have permission to access this application feature');
        } else if (status === 503 || status === 404) {
            // TODO: PERFORMANCE - Using && operator for side effects instead of if statement makes code less readable
            errorMsg && toastError(`${errorMsg} \nPlease try again.`, 8000);
        } else {
            toastError(errorMsg ?? 'An error occurred while processing your request.', 8000);
        }
    };

    return {
        processApiEndpointError,
    };
};
